import { ASSESSMENT_LABELS, daysSince } from '../assessmentResults/constants';

const timeFormat = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' });
const dayFormat = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
const longFormat = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
const shortFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
const weekdayFormat = new Intl.DateTimeFormat('en-US', { weekday: 'long' });

/** "2026-10-02" and "14:00" as a local Date. */
export const atTime = (isoDate, time = '00:00') => new Date(`${isoDate}T${String(time).slice(0, 5)}:00`);
export const dateOnly = (isoDate) => atTime(String(isoDate).slice(0, 10));

export const formatTime = (date) => timeFormat.format(date);
export const formatDay = (date) => dayFormat.format(date);
export const formatLong = (date) => longFormat.format(date);
export const formatShort = (date) => shortFormat.format(date);
export const formatWeekday = (date) => weekdayFormat.format(date);

/** today, yesterday, or "N days ago". */
export const relativeDays = (value) => {
  const days = daysSince(value);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days} days ago`;
};

export const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** "today", "tomorrow" or the weekday, for a session date. */
export const sessionDay = (isoDate) => {
  const day = dateOnly(isoDate);
  const today = new Date();
  if (sameDay(day, today)) return 'today';
  const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
  if (sameDay(day, tomorrow)) return 'tomorrow';
  return formatWeekday(day);
};

export const FOLLOW_UP_REASON = {
  dass42: 'dass_followup',
  sdq: 'sdq_followup',
  ryff: 'ryff_followup',
  riasec: 'riasec_followup',
};

/** Level and section in the short form the review table uses ("Nursing – BSN 2-A"). */
export const groupText = (student) => {
  const level = (student.level || '').replace(/^College of /, '');
  if (level && student.section) return `${level} – ${student.section}`;
  return student.section || level || 'No section';
};

export const assessmentLabel = (type) => ASSESSMENT_LABELS[type] || type;

/** The server's own message (it explains limits and switches), or a fallback. */
export const apiError = (failure, fallback) => failure?.response?.data?.error || failure?.response?.data?.detail || fallback;
